import * as React from "react";

import { cn } from "~/lib/utils";

interface FormProps extends React.ComponentProps<"form"> {
  /** Called on form submit (Enter on input or Ctrl/Cmd+Enter anywhere) */
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
}

function Form({ className, onSubmit, onKeyDown, ...props }: FormProps) {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLFormElement>) => {
    // Ctrl/Cmd+Enter submits from anywhere in the form
    if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) {
      e.preventDefault();
      e.currentTarget.requestSubmit();
    }
    onKeyDown?.(e);
  };

  return <form className={cn(className)} onSubmit={onSubmit} onKeyDown={handleKeyDown} {...props} />;
}

export { Form };
